export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_af445cfc27fa4ea32607c0e8